import ApplicationSerializer from 'volta/_pods/application/serializer';

export default class SimulationItemSettingTaskSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string) {
    if (key === 'tasks') {
      return 'simulation-item-setting-task';
    }
    return super.modelNameFromPayloadKey(key);
  }
}
